import React, { Component } from "react";
import { TouchableHighlight } from "react-native";
import Text from "../TextFont";
import Theme from "../../argon-ui/Theme";
import FontAwesomeIcon from "../FontAwesomeIcon";
import { HStack } from "native-base";
import { getDir } from "../../util";

/**@augments {Component<props,state>}*/
class RBSheetInnerAreaState extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  handleOnIconPress = () => {
    typeof this.props.onIconPress === "function" && this.props.onIconPress();
  };
  handleOnTextPress = () => {
    typeof this.props.onTextPress === "function" && this.props.onTextPress();
  };
  handleOnTogglePress = () => {
    typeof this.props.onTogglePress === "function" &&
      this.props.onTogglePress();
  };
  render() {
    return (
      <TouchableHighlight
        underlayColor="#FFF"
        // onPress={() => {
        //   this.props.onPress && this.props.onPress();
        // }}
        onPress={this.handleOnTogglePress}
        style={{
          backgroundColor: this.props.highlighted ? "#eee" : "#fff",
          direction: getDir(),
        }}
      >
        <HStack
          justifyContent="space-between"
          alignItems="center"
          px="5"
          style={{
            minHeight: 55,
            borderBottomColor: "#eee",
            borderBottomWidth: 1,
          }}
        >
          <HStack space="4">
            <FontAwesomeIcon
              icon={this.props.stateIcon}
              size={18}
              color={
                this.props.value ? Theme.COLORS.PRIMARY : Theme.COLORS.MUTED
              }
              style={{ paddingTop: 5 }}
            />
            <Text
              style={{
                fontSize: 18,
                color: "#666666",
              }}
            >
              {this.props.text}
            </Text>
          </HStack>
          {this.props.icon !== "" && (
            <FontAwesomeIcon
              icon={this.props.icon}
              size={26}
              color={Theme.COLORS.MUTED}
            />
          )}
        </HStack>
      </TouchableHighlight>
    );
  }
}

export default RBSheetInnerAreaState;
